import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import DesignerDialogs from '../components/DesignerDialogs';
import SessionDesigner from './DesignerComponents';
import RDesignerTOCContent from './DesignerTOC';

import { getStore } from '../../../state/store';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

import Console from '../../../lib/debug';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import SecondaryButton from '../../common/component/SecondaryButton';

const RDesignerWrapper = props => {
    return (
        <div className="th-designer">
            <DesignerDialogs />
            <div className="designer-body">
                <RDesignerTOCContent />
                <RDesigner {...props} />
            </div>
        </div>
    );
};

class RDesigner extends PureComponent {
    itemListRenderer(items) {
        return <div className="items-list">{items}</div>;
    }

    trackBackToCalendar() {
        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Back to Calendar'
        });
    }

    renderItem() {
        let classes = 'day-item ';
        const dispatch = getStore().dispatch;
        return (
            <div className={classes}>
                <SessionDesigner
                    dayId={this.props.config.dayId}
                    isProgram={this.props.isProgram}
                    dispatch={dispatch}
                />
            </div>
        );
    }

    render() {
        Console.render('Designer');
        let items = this.renderItem.call(this);
        let itemList = this.itemListRenderer(items);
        let body = <div className="r-designer designer">{itemList}</div>;
        const arrowStyles = {
            marginRight: 3,
            width: 16,
            height: 16
        };
        const dayId = this.props.config.dayId;
        const buttonHref = this.props.isProgram ? '../' : `./?id=${dayId}`;
        const buttonTitle = this.props.isProgram
            ? 'Back to Program'
            : 'Back to Calendar';

        return (
            <div className="day-view-wrapper">
                <div className="back-to-calendar-wrapper">
                    <SecondaryButton
                        variant="raised"
                        aria-label={buttonTitle}
                        onClick={() => this.trackBackToCalendar()}
                        href={buttonHref}
                    >
                        <ArrowBackIcon style={arrowStyles} />
                        <span style={{ marginTop: -2 }}>{buttonTitle}</span>
                    </SecondaryButton>
                </div>
                {body}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        config: state.calendar.infoTree.designerInfo,
        isProgram: ProgramTypes.isProgram(state.calendar.infoTree.programType)
    };
};

RDesigner = connect(mapStateToProps)(RDesigner);

export default RDesignerWrapper;



// WEBPACK FOOTER //
// ./src/view/designer/designer-base/Designer.jsx